import { createFileRoute } from "@tanstack/react-router";
import { ListiclePage, buildListicleHead, type ListiclePageConfig } from "@/components/ListiclePage";

const CONFIG: ListiclePageConfig = {
  slug: "best-web-design-agencies-denver",
  metaTitle: "Best Web Design Agencies in Denver (Ranked) | Colorado Web Impressions",
  metaDescription: "An editorial ranking of the top web design agencies in Denver, Colorado — what they do well, who they're for, and how pricing compares.",
  breadcrumbs: [
    { label: "Home", to: "/" },
    { label: "Insights", to: "/learn" },
  ],
  currentLabel: "Best Agencies — Denver",
  eyebrow: "Best Agencies — Denver",
  h1: <>{"The Best Web Design Agencies in Denver"}</>,
  heroDescription: "An honest editorial breakdown of the top web design shops in Denver — who they serve, what they charge, and where each shines.",
  intro: "Choosing a web design agency in Denver is high-stakes — the wrong pick costs you 12+ months of stalled leads. We've worked alongside (and competed with) most of the shops on this list. Here's an honest breakdown of who's strong at what.",
  methodology: ["Mobile-first load speed (Lighthouse on 4G throttle)", "Above-the-fold conversion design", "Service + service-area page depth", "On-page SEO + schema (FAQ, Service, LocalBusiness)", "Real local photography vs stock imagery"],
  items: [
    {
      rank: 1,
      name: "Colorado Web Impressions",
      city: "Denver, CO",
      whatWeLike: ["Owner-led — you work directly with Chris, not an account manager", "Hand-coded, no page builders or WordPress bloat", "Transparent pricing published on the site", "Denver office; on-the-ground local knowledge"],
      takeaway: "Our pick because it's the rare Denver shop that combines design, dev, and SEO under one owner — and publishes pricing openly.",
    },
    {
      rank: 2,
      name: "A long-established Denver brand agency",
      city: "Denver, CO",
      whatWeLike: ["Strong creative direction", "Recognized local clients"],
      watchOuts: ["Slower turnaround; not always SEO-first"],
    },
    {
      rank: 3,
      name: "A boutique WordPress shop",
      city: "Denver, CO",
      whatWeLike: ["Solid mid-market positioning", "Good for content-heavy sites"],
      watchOuts: ["WordPress technical debt accumulates fast"],
    },
    {
      rank: 4,
      name: "A Shopify-focused e-commerce agency",
      city: "Denver, CO",
      whatWeLike: ["Strong ecom conversion design", "Solid app integrations"],
      watchOuts: ["Less competitive on service-business SEO"],
    },
    {
      rank: 5,
      name: "A national agency with a Denver office",
      city: "Denver, CO",
      whatWeLike: ["Big team, big-brand polish", "Strong project management"],
      watchOuts: ["Premium pricing; local owners may feel like a small fish"],
    },
    {
      rank: 6,
      name: "An indie freelance designer collective",
      city: "Denver, CO",
      whatWeLike: ["Tight, personal service", "Fair pricing for simple sites"],
      watchOuts: ["Limited dev capacity for complex builds"],
    }
  ],
  closing: "If your Denver agency search doesn't deliver on these fundamentals, you're leaving money on the table every single day. Talk to us.",
  relatedLinks: [
    { to: "/colorado-springs", label: "colorado springs" },
    { to: "/case-studies", label: "case studies" }
  ],
};

export const Route = createFileRoute("/best-web-design-agencies-denver")({
  head: () => buildListicleHead(CONFIG),
  component: () => <ListiclePage config={CONFIG} />,
});
